// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"fac9ee0bade96454","5285":"8207b19b64a7eab3"}[chunkId] + ".css";
};